<template>
  <div
    class="fixed inset-0 z-50 bg-gray-800/50 p-20"
    data-el="youtube-iframe-container"
    @click="clicked"
    @keydown="clicked"
  >
    <div class="fixed right-20 top-20 z-50 -translate-y-1/2 translate-x-1/2">
      <button
        class="relative rounded-full bg-white p-6"
        type="button"
        data-el="youtube-video-close"
        @click="clicked"
      >
        <Icon
          class="text-md absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
          icon="close"
        />
      </button>
    </div>
    <iframe
      class="h-full w-full shadow-2xl"
      :ref="target"
      :src="iframeSrc"
      frameborder="0"
      allow="autoplay; encrypted-media"
      allowfullscreen
      title="YouTube Video"
    />
  </div>
</template>
<script lang="ts" setup>
import { onClickOutside } from '@vueuse/core';
import { computed, ref } from 'vue';
import Icon from '../../components/form/Icon.vue';

const props = defineProps<{ videoId: string }>();
const iframeSrc = computed(() => {
  const base = `https://www.youtube-nocookie.com/embed/${props.videoId}`;
  const autoplay = '1';
  const mute = '0';
  const start = '0';
  return `${base}?autoplay=${autoplay}&mute=${mute}&start=${start}`;
});

const target = ref(null);
const emit = defineEmits<{ (e: 'click'): void }>();
const clicked = () => {
  emit('click');
};
onClickOutside(target, () => clicked());
</script>
